export const isReadOnly = (user) => !!user && user.is_read_only === true

export const canWrite = (user) => !!user && !isReadOnly(user)
